const reportReviewES = {
	title: "Reportar Reseña",
	subtitle: "¿Por qué estás reportando esta reseña?",
	reason: {
		spam: "Spam o falso",
		inappropriate: "Inapropiado u ofensivo",
		harassment: "Acoso o intimidación",
		incorrect: "Información incorrecta",
		other: "Otro",
	},
	placeholder: "Agrega más detalles (opcional)",
	actions: {
		cancel: "Cancelar",
		submit: "Enviar reporte",
		success: "Reporte enviado",
	},
};

export default reportReviewES;
